export const PASSWORD_DEFAULT_FOR_ADMIN_USERS = 'mana2023';
